module.exports = __webpack_public_path__ + "img/qy1@2x.616f9d0e.png";